/*
 * common.funcs.js
 */

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);
// window resize
window.addEventListener('resize', () => {
  vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});


var queryString = window.location.search;
var queryObject = new Object();
if(queryString){
  queryString = queryString.substring(1);
  var parameters = queryString.split('&');

  for (var i = 0; i < parameters.length; i++) {
    var element = parameters[i].split('=');

    var paramName = decodeURIComponent(element[0]);
    var paramValue = decodeURIComponent(element[1]);

    queryObject[paramName] = paramValue;
  }
}

var scroll = new SmoothScroll('a[smoothscroll]', {
  speed: 500,
  speedAsDuration: true,
  header: '[data-scroll-header]',
  easing: 'easeOutQuad',
  updateURL: false
});


var gNavFunc = function () {
  var timer = false;

  // 下記は変更できます。
  var $menuBtn = $('.menuBtn');
  var $navigation = $('.gnav');

  var init = function init() {
    bind();
  };

  var bind = function bind() {
    var lastInnerWidth = 0;
    $(window).bind('load resize', function () {
      if (timer !== false) {
        clearTimeout(timer);
      }
      timer = setTimeout(function () {
        if (window.innerWidth > 980) {
          reset.init();
          menuFuncs();
        } else {
          if (lastInnerWidth != window.innerWidth) {
            reset.init();
            menuFuncs();
          }
        }
        lastInnerWidth = window.innerWidth;
      }, 100);
    });
  };

  var menuFuncs = function menuFuncs() {
    $menuBtn.on('click', function () {
      $(this).toggleClass('is-open');
      $navigation.toggleClass('is-open');

      if($(this).hasClass('is-open')){
        $('.menuBtn_txt').text('CLOSE');
      }
      else{
        $('.menuBtn_txt').text('MENU');
      }
    });
  };

  var reset = {
    init: function init() {
      // すべてリセット
      $menuBtn.off('click').removeClass('is-open');
      $navigation.removeClass('is-open');
      $('.menuBtn_txt').text('MENU');
    }
  };
  return {
    init: init
  };
}().init();



$(function() {
  $('.modal-btn').magnificPopup({
    type: 'ajax',
    showCloseBtn: false,
    ajax: {
      settings: null,
      cursor: 'mfp-ajax-cur',
      tError: '<a href="%url%">The content</a> could not be loaded.'
    },
    callbacks: {
      beforeOpen: function() {
        this.st.mainClass = 'mfp-zoom-in';
      },
      ajaxContentAdded: function() {
        // Ajax content is loaded and appended to DOM
        $('.modalClose').on('click', function(e){
          e.preventDefault();
          $.magnificPopup.close();
        });
      }
    },
  });
});


// $(window).bind('load', function () {
//   if(location.hash){
//     var goto = location.hash.replace('#', '');
//     var scroll2 = new SmoothScroll();
//     var anchor = document.getElementById(goto);
//     var toggle = document.getElementById(goto);
//     var options = {
//       speed: 1000,
//       offset: function (anchor, toggle) {
//         return $('.header').outerHeight();
//       },
//     };
//     scroll2.animateScroll(anchor, toggle, options);
//   }
// });
